import { makeStyles } from '@material-ui/core/styles';
import React, { useState } from 'react';
import {
    BooleanInput,
    Create,
    DateInput,
    FormDataConsumer,
    SimpleForm,
    TextInput,
    required,
    useTranslate,
} from 'react-admin';
import { Typography } from '@material-ui/core';
import SpeakerNotesIcon from '@material-ui/icons/SpeakerNotes';
import {
    ContainerFieldsList,
    CustomBreadcrumbs,
    CustomSelectArrayInput,
    CustomSelectInput,
} from 'candy-commons-components';
import countries from '../../data/countries.json';
import languages from '../../data/languages.json';
import popupTypes from '../../data/serviceCommunications.popupTypes.json';

import { useSelector } from 'react-redux';
import {
    getApplianceTypes,
    getBrands,
    getSeries,
} from '../../selectors/cmsConfig';
const useStyles = makeStyles({
    width: {
        width: '100% !important',
    },
});
const ServiceCommunicationsList = ({ permissions, ...props }) => {
    const translation = useTranslate();
    const classes = useStyles();
    const applianceTypes = useSelector(getApplianceTypes);
    const brands = useSelector(getBrands);
    const series = useSelector(getSeries);
    const breadcrumbsData = [
        {
            text: translation('resources.service-communications.name'),
            url: 'service-communications',
            icon: <SpeakerNotesIcon />,
        },
        {
            text: translation('resources.service-communications.create.name'),
            url: '',
        },
    ];
    const [allApplianceFlag, setAllApplianceFlag] = useState(false);
    const handleAllAppliance = (e) => setAllApplianceFlag(e?.target?.checked);
    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <Create {...props}>
                <SimpleForm>
                    <Typography style={{ paddingTop: 10 }}>
                        {translation(
                            'resources.service-communications.titles.settings'
                        )}
                    </Typography>
                    <ContainerFieldsList>
                        <TextInput
                            source="popupId"
                            label="Popup Id"
                            validate={required()}
                        />
                        <CustomSelectInput
                            source="popupType"
                            label="Popup Type"
                            choices={popupTypes}
                            validate={required()}
                        />
                        <BooleanInput source="active" label="active" />
                    </ContainerFieldsList>
                    <hr className={classes.width} />
                    <Typography style={{ paddingTop: 10 }}>
                        {translation(
                            'resources.service-communications.titles.content'
                        )}
                    </Typography>
                    <TextInput
                        source="title"
                        label="Title"
                        fullWidth
                        validate={required()}
                    />
                    <TextInput
                        source="body"
                        label="Body Content"
                        fullWidth
                        multiline
                        validate={required()}
                    />
                    <hr className={classes.width} />
                    <Typography style={{ paddingTop: 10 }}>
                        {translation(
                            'resources.service-communications.titles.criteria'
                        )}
                    </Typography>
                    <ContainerFieldsList>
                        <FormDataConsumer>
                            {() => (
                                <>
                                    {!allApplianceFlag && (
                                        <CustomSelectArrayInput
                                            label="Appliance types"
                                            source="applianceType"
                                            choices={applianceTypes}
                                            disabled={allApplianceFlag}
                                        />
                                    )}
                                    <BooleanInput
                                        source="AllAppliances"
                                        onClick={handleAllAppliance}
                                    />
                                </>
                            )}
                        </FormDataConsumer>
                    </ContainerFieldsList>
                    <ContainerFieldsList>
                        <CustomSelectInput
                            source="series"
                            label="Series"
                            choices={series}
                        />
                        <TextInput
                            label="Series Version"
                            source="seriesVersion"
                        />
                        <CustomSelectInput
                            source="brand"
                            label="Brand"
                            choices={brands}
                        />
                        <CustomSelectInput
                            source="language"
                            label="App Language"
                            choices={languages}
                        />
                        <TextInput
                            source="minAppVersion"
                            label="Minimum App Version"
                        />
                        <TextInput
                            source="maxAppVersion"
                            label="Maximum App Version"
                        />
                        <DateInput
                            source="startTime"
                            label="Start Time"
                            validate={required()}
                        />
                        <DateInput
                            source="endTime"
                            label="End Time"
                            validate={required()}
                        />
                        <CustomSelectArrayInput
                            label="countries"
                            source="countries"
                            choices={countries}
                        />
                        <BooleanInput
                            source="countriesToExclude"
                            label="Are countries to exclude?"
                        />
                    </ContainerFieldsList>
                </SimpleForm>
            </Create>
        </>
    );
};
export default ServiceCommunicationsList;
